import Hero from '../components/Hero';
import Offers from '../components/Offers';
import About from '../components/About';
import Guides from '../components/Guides';
import FAQ from '../components/FAQ';
import News from '../components/News';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <main>
      <Hero />
      <Offers />
      <About />
      <Guides />
      <FAQ />
      <News />
      <Contact />
    </main>
  );
};

export default Home;

